module.exports = __webpack_public_path__ + "static/media/ic-bath-grey.94e71c53.svg";